<template>
  <v-app
    id="inspire"
    :key="person.personID"
    @click.native="resetTimeout()"
  >
    <!-- admin menu -->
    <v-navigation-drawer
      v-if="authenticated && !navHidden"
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawerOpen"
      class="nav-Drawer elevation-10"
      fixed
      app
    >
      <v-list dense>
        <UserSearchBar v-if="assertSetting('personLoad', 1)"/>
        <User />
        <Reports v-if="assertSetting('viewReports', 1)"/>
        <Config v-if="assertSetting('editConfig', 1)"/>
      </v-list>
      <v-footer
        v-if="primaryPerson.personGroupID == '1'"
        absolute
        color="warning"
        dark
      >
        <v-layout
          class="headline"
          justify-space-around
          align-center
        >
          <v-icon>phone</v-icon>
          <div> {{ settings.textHelp }}</div>
        </v-layout>
      </v-footer>
    </v-navigation-drawer>
    <!-- navbar -->
    <v-toolbar
      v-if="!navHidden"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="green darken-3"
      dark
      app
      fixed
    >
      <!-- admin menu button -->
      <v-toolbar-side-icon
        v-if="authenticated"
        @click.stop="drawerOpen = !drawerOpen"/>
      <!-- logo and title -->
      <v-toolbar-title
        style="width: 500px"
        class="clickable ml-0 pl-3"
        @click="$router.push({path: '/'})"
      >
        <v-btn
          icon
          large
        >
          <v-avatar
            size="32px"
            tile
          >
            <img
              src="@/assets/logo.png"
              alt="Baxter State Park"
            >
          </v-avatar>
        </v-btn>
        <span class="hidden-sm-and-down">Baxter State Park - Reservations</span>
      </v-toolbar-title>
      <v-spacer/>
      <!-- user menus -->
      <v-toolbar-items>
        <template v-if="authenticated">
          <CartDropdown v-if="showCartIcon"/>
        </template>
        <template v-else>
          <v-btn
            :to="{path: '/signin'}"
            flat>Log In
          </v-btn>
          <v-btn
            :to="{path: '/signin/signup'}"
            flat>Sign Up
          </v-btn>
        </template>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <Alerts/>
      <Notifications/>
      <v-container
        fluid
        fill-height>
        <v-layout justify-center>
          <v-flex>
            <!-- refresh on personid change or timeout -->
            <router-view/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
// import components
import CartDropdown from '@/components/navigation/CartDropdown'
import UserSearchBar from '@/components/navigation/UserSearchBar'
import User from '@/components/navigation/User'
import Reports from '@/components/navigation/Reports'
import Config from '@/components/navigation/Config'
import Alerts from '@/components/info/Alerts'
import Notifications from '@/components/info/Notifications'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    CartDropdown,
    UserSearchBar,
    User,
    Reports,
    Config,
    Alerts,
    Notifications
  },
  props: {
    source: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    drawerOpen: null,
    timeoutFunction: null
  }),
  computed: {
    ...mapGetters({
      authenticated: 'person/authenticated',
      person: 'person/person',
      timeout: 'person/timeout',
      primaryPerson: 'person/primaryPerson'
    }),
    timeoutLength () {
      return (Number(this.settings?.miscTimeout) || 10) * 60 * 1000
    },
    navHidden () {
      return this.$route.matched.some(m => m.meta.navHidden)
    },
    showCartIcon () {
      return !this.$route.matched.some(record => record.path === '/checkout')
    }
  },
  mounted () {
    this.getPersonSettings()

    // create a stylesheet for printing
    let printStyle = document.createElement('style')
    printStyle.setAttribute('id', 'printStyle')
    printStyle.setAttribute('media', 'print')
    document.head.appendChild(printStyle)
  },
  methods: {
    ...mapMutations({
      setTimeout: 'person/setTimeout',
      newNotification: 'info/newNotification'
    }),
    ...mapActions({
      loadFacilities: 'facilities/loadFacilities',
      getPersonSettings: 'person/getPersonSettings'
    }),
    resetTimeout () {
      /*
      clearTimeout(this.timeoutFunction)
      if (this.timeout === true) {
        this.setTimeout(false)
      }
      this.timeoutFunction = setTimeout(() => {
        this.setTimeout(true)
        this.$router.push({path: '/'})
        this.newNotification({message: 'You timed out. We kept you logged in, but yor cart has been reset'})
      }, this.timeoutLength)
      */
    }
  }
}
</script>

<style lang="scss">
  @import './assets/main.scss';
</style>
<style lang="css">
    @import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
</style>
